import React from "react";
import { Fragment } from "react";
import { ToastContainer } from "react-toastify";
import PeerRoutes from "./routes/PeerRoutes";
import DashBoardRoutes from "./routes/DashboardRoutes";
import LoginRoutes from "./routes/LoginRoutes";
import JobReqRoutes from "./routes/JobReqRoutes";
import PeerRejectRoutes from "./routes/PeerRejectRoutes";
import SSOLoginRoutes from "./routes/SSOLoginRoutes";
import { StorageService } from "./services/StorageService";
import { StorageValues } from "./constants/storageValues";
import { Stringutility } from "./utilities/stringutility";
import AllJobRoutes from "./routes/AllJobRoutes";
import AllJobs from "./views/app/dashboard/AllJobs/allJobs";
import FindJobs from "./views/app/dashboard/FindJobs/findJobs";
// import Demo from "../src/Demo";
const App = () => {
  const url = window.location.href;
  const query = new URLSearchParams(window.location.search);
  if (!Stringutility.isNullOrEmpty(query.get("p"))) {
    const page = query.get("p");
    StorageService.saveInLocalStorage(StorageValues.PAGE,page)
  }
  if (!Stringutility.isNullOrEmpty(query.get("authToken"))) {
    const authToken = query.get("authToken");
    StorageService.saveInLocalStorage(StorageValues.AUTH_TOKEN,authToken)
  }
  if (!Stringutility.isNullOrEmpty(query.get("jobId"))) {
    const jobId = query.get("jobId").trim();
    StorageService.saveInSessionStorage(StorageValues.JOB_ID,jobId)
  }
  if (!Stringutility.isNullOrEmpty(query.get("flavor"))) {
    const flavor = query.get("flavor").trim();
    StorageService.saveInSessionStorage(StorageValues.FLAVOR,flavor)
  }
   if (!Stringutility.isNullOrEmpty(query.get("templateName"))) {
    const template = query.get("templateName").trim();
    StorageService.saveInSessionStorage(StorageValues.TEMPLATE_NAME,template)
  }
  if (!Stringutility.isNullOrEmpty(query.get("id"))) {
    const peerRatingId = query.get("id");
    StorageService.saveInSessionStorage(StorageValues.PEER_RATING_ID,peerRatingId)
    StorageService.saveInSessionStorage("searchJobId",peerRatingId)
  }
  if (!Stringutility.isNullOrEmpty(query.get("id"))) {
    const searchJobs = query.get("id");
    StorageService.saveInSessionStorage("searchJobId",searchJobs)
  }
  if (!Stringutility.isNullOrEmpty(StorageService.getFromLocalStorage(StorageValues.PAGE))) {
    let page=StorageService.getFromLocalStorage(StorageValues.PAGE);
    if (page == "proxylogin") {
      StorageService.saveInLocalStorage(StorageValues.PROFILE,"completed")
      if (!Stringutility.isNullOrEmpty(query.get("candidateId"))) {
        const candidateId = query.get("candidateId");
        StorageService.saveInLocalStorage(StorageValues.USER,candidateId)
      }
    }
  }
  const Basicroutes = () => {
    const p = StorageService.getFromLocalStorage(StorageValues.PAGE)
    const peerRatingId =StorageService.getFromSessionStorage(StorageValues.PEER_RATING_ID)
    const searchJobId=StorageService.getFromSessionStorage("searchJobId");
    return (
      <div>
        {(() => {
          if (Stringutility.isNullOrEmpty(p)) {
            if (!Stringutility.isNullOrEmpty(query.get("sso"))){
              return <SSOLoginRoutes/>
            }else{
              return <LoginRoutes />;
            }
          } else if (p == "proxylogin") {
            return <DashBoardRoutes />;
          } else if (p == "jobreq") {
            return <JobReqRoutes />;
          } else if (p == "peerrating") {
            if (Stringutility.isNullOrEmpty(peerRatingId)) {
              return <LoginRoutes />;
            } else {
              return <PeerRoutes peerRatingId={peerRatingId}/>;
            }
          } else if (p == "peerreject") {
            if (Stringutility.isNullOrEmpty(peerRatingId)) {
              return <LoginRoutes />;
            } else {
              return <PeerRejectRoutes peerRatingId={peerRatingId}/>;
            }
          }  else if (p == "findJobs") {
            if (Stringutility.isNullOrEmpty(searchJobId)) {
              return <LoginRoutes />;
            } else {
              return <FindJobs/>;
            }
          }
          else {
            return <LoginRoutes />;
          }
        })()}
      </div>
    );
  };
  return (
    <Fragment>
      <Basicroutes></Basicroutes>
      <ToastContainer
      className="t-toast-width Toastify__toast-container--top-center "
        rtl={true}
        autoClose={6000}
        draggable={true}
        closeButton={true}
        pauseOnHover={true}
      />
    </Fragment>
    // <Demo/>
  );
};
export default App;